import { render } from "./Publicize.vue?vue&type=template&id=7c0f05f5&scoped=true"
import script from "./Publicize.vue?vue&type=script&lang=js"
export * from "./Publicize.vue?vue&type=script&lang=js"

import "./Publicize.vue?vue&type=style&index=0&id=7c0f05f5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Z\\Desktop\\7\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0f05f5"]])

export default __exports__